import { useState, useEffect, useRef } from 'react';
import { getDatabase, ref, onValue } from 'firebase/database';
import { useAuth } from '../contexts/AuthContext';
import notificationSound from '../assets/notification.mp3';

const playNotificationSound = () => {
    try {
        const audio = new Audio(notificationSound);
        audio.play().catch(e => console.error("Audio playback failed because user hasn't interacted with document yet", e));
    } catch (e) {
        console.error("Audio playback failed", e);
    }
};

export default function useUnreadCount() {
    const { currentUser } = useAuth();
    const [unreadCount, setUnreadCount] = useState(0);
    const lastUnreadTimestampRef = useRef(0);
    const initialLoadRef = useRef(true);

    useEffect(() => {
        if (!currentUser) return;

        const db = getDatabase();
        const chatsRef = ref(db, 'chats');

        const unsubscribe = onValue(chatsRef, (snapshot) => {
            if (!snapshot.exists()) {
                setUnreadCount(0);
                initialLoadRef.current = false;
                return;
            }

            let count = 0;
            let latestTimestamp = 0;

            snapshot.forEach((childSnapshot) => {
                const chat = childSnapshot.val();

                if (chat.senderId === currentUser.uid || chat.receiverId === currentUser.uid) {
                    const isUnread =
                        chat.lastSenderId &&
                        chat.lastSenderId !== currentUser.uid &&
                        ((chat.senderId === currentUser.uid && chat.senderReadStatus === 0) ||
                            (chat.receiverId === currentUser.uid && chat.receiverReadStatus === 0));

                    if (isUnread) {
                        count++;

                        if (chat.messages && chat.messages.length > 0) {
                            const lastMsg = chat.messages[chat.messages.length - 1];
                            const msgTime = lastMsg.timestamp || 0;
                            if (msgTime > latestTimestamp) {
                                latestTimestamp = msgTime;
                            }
                        }
                    }
                }
            });

            setUnreadCount(count);

            if (!initialLoadRef.current) {
                if (latestTimestamp > lastUnreadTimestampRef.current && count > 0) {
                    playNotificationSound();
                }
            } else {
                initialLoadRef.current = false;
            }
            lastUnreadTimestampRef.current = latestTimestamp;
        });

        return () => unsubscribe();
    }, [currentUser]);

    return unreadCount;
}
